import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Navbar = (props) => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentHour, setCurrentHour] = useState("");
  const [currentMin, setCurrentMin] = useState("");
  const [currentSec, setCurrentSec] = useState("");
  const [ampm, setAMPM] = useState("");

  useEffect(() => {
    getCurrentDateTime();
    const timerID = setInterval(() => getCurrentDateTime(), 1000);
    return () => {
      clearInterval(timerID);
    };
  }, []);

  const getCurrentDateTime = () => {
    const currentTime = new Date();
    let currentHour = String(currentTime.getHours()).padStart(2, "0");
    const currentMin = String(currentTime.getMinutes()).padStart(2, "0");
    const currentSec = String(currentTime.getSeconds()).padStart(2, "0")
    const currentDate = currentTime.toDateString();
    const ampm = currentHour >= 12 ? 'PM' : 'AM';
    currentHour = currentHour % 12 || 12; // Convert hour to 12-hour format

    setCurrentDate(currentDate);
    setCurrentHour(currentHour);
    setCurrentMin(currentMin);
    setCurrentSec(currentSec);
    setAMPM(ampm);
  }

  const handleLanguageChange = (languageCode) => {
    props.setSelectedLanguage(languageCode);
  };
  return (
    <div>
      <nav className={`navbar navbar-expand-lg bg-${props.mode} navbar-dark`}>
        <div className="container-fluid">
          <Link className="navbar-brand" to="/newsydoozy">
            NewsyDoozy
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/home"
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" to="/business">
                  Business
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" to="/education">
                  Education
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" to="/entertainment">
                  Entertainment
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" to="/health">
                  Health
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" to="/science_and_technology">
                  Science and Technology
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link active" to="/general">
                  General
                </Link>
              </li> */}
              <li className="nav-item">
                <Link className="nav-link active" to="/sports">
                  Sports
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" to="/travel">
                  Travel
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link active" to="/technology">
                  Technology
                </Link>
              </li> */}
              <li className="nav-item">
                <Link className="nav-link active" to="/about">
                  About Us
                </Link>
              </li>
            </ul>
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 mx-4">
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle active" id="userDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                  Language
                </button>
                <ul className="dropdown-menu" aria-labelledby="userDropdown">
                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange('en')}
                  >
                    English
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange('hi')}
                  >
                    Hindi
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange('mr')}
                  >
                    Marathi
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange('bn')}
                  >
                    Bengali
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange('ta')}
                  >
                    Tamil
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange('te')}
                  >
                    Telegu
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange('ml')}
                  >
                    Malayalam
                  </button>
                </ul>
              </li>
            </ul>
            <div className="mx-3" style={{ fontSize: '22px', fontWeight: 'bold', color: 'white' }}>
              {currentDate}, {currentHour}:{currentMin}:{currentSec} {ampm}
            </div>
            <div className="text-light mx-3">
              {props.mode === "primary" ? (
                <i className="fas fa-moon" onClick={props.toggleMode} style={{ cursor: 'pointer' }} />
              ) : (
                <i className="fas fa-sun" onClick={props.toggleMode} style={{ cursor: 'pointer' }} />
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
